import React, { useState } from "react";
import NewsCard from "./NewsCard";
import "../styles/News.css";

function News() {
  const NEWS_CATCHER_API_KEY = process.env.REACT_APP_NEWS_CATCHER_API_KEY;

  const [inputValue, setInputValue] = useState("");
  const [articles, setArticles] = useState([]);
  const [titles, setTitles] = useState([]);
  const [dates, setDates] = useState([]);
  const [borderStyle, setBorderStyle] = useState("");

  const search = (e) => {
    e.preventDefault();
    setArticles([]);
    setTitles([]);
    setDates([]);
    if (inputValue === "") {
      alert("Search something !");
      setBorderStyle("");
    } else {
      fetch(
        `https://newscatcher.p.rapidapi.com/v1/search_free?q=${inputValue}&lang=en&media=True`,
        {
          method: "GET",
          headers: {
            "x-rapidapi-host": "newscatcher.p.rapidapi.com",
            "x-rapidapi-key": NEWS_CATCHER_API_KEY,
          },
        }
      )
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
        })
        .then((response) => {
          for (let index = 0; index < 5; index++) {
            console.log(response);
            if (response.articles.hasOwnProperty(`${[index]}`)) {
              setArticles((articles) => [
                ...articles,
                response.articles[index].summary,
              ]);
              setTitles((titles) => [
                ...titles,
                response.articles[index].title,
              ]);
              setDates((dates) => [
                ...dates,
                response.articles[index].published_date,
              ]);
            } else {
              setArticles((articles) => [
                ...articles,
                "No resources available",
              ]);
              setTitles((titles) => [...titles, ""]);
              setDates((dates) => [...dates, ""]);
            }

            setBorderStyle("card border border-primary");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      setInputValue("");
    }
  };

  return (
    <>
      <form className="form-container" onSubmit={search}>
        <input
          className="form-control"
          type="text"
          name="search"
          placeholder="Your search"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
          }}
        />
        <button className="btn btn-primary">Search</button>
      </form>
      <div className="card-group">
        <NewsCard
          articles={articles[0]}
          titles={titles[0]}
          dates={dates[0]}
          border={borderStyle}
        />
        <NewsCard
          articles={articles[1]}
          titles={titles[1]}
          dates={dates[1]}
          border={borderStyle}
        />
        <NewsCard
          articles={articles[2]}
          titles={titles[2]}
          dates={dates[2]}
          border={borderStyle}
        />
        <NewsCard
          articles={articles[3]}
          titles={titles[3]}
          dates={dates[3]}
          border={borderStyle}
        />
        <NewsCard
          articles={articles[4]}
          titles={titles[4]}
          dates={dates[4]}
          border={borderStyle}
        />
      </div>
    </>
  );
}

export default News;
